import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Wrench } from 'lucide-react';
import { Button } from './ui/button';
import { engineerImage } from '../mock';

const EngineersSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full bg-[#FCE0EC] blur-2xl -z-10" />
            <div className="rounded-[36px] overflow-hidden shadow-xl aspect-[4/5] max-h-[560px]">
              <img src={engineerImage} alt="Qualified UK engineer" className="w-full h-full object-cover" />
            </div>

            <div className="absolute -bottom-6 right-4 md:-right-6 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-[#1F0068] text-white flex items-center justify-center">
                <Wrench className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs text-[#1F0068]/60">UK network</div>
                <div className="text-sm font-bold text-[#1F0068]">of service providers</div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FF5C39] mb-3">Our service partners</div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-[1.05]">
              Qualified engineers, arranged when you need them
            </h2>
            <p className="mt-5 text-lg text-[#1F0068]/70 leading-relaxed">
              When a repair or maintenance visit is required under your service plan, we arrange the appropriate engineer through our network of independent UK service providers. Availability and appointment times are confirmed at the point of booking.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/dashboard/new">
                <Button className="squircle h-14 px-8 bg-[#1F0068] hover:bg-[#2A0C7A] text-white text-base font-semibold">
                  Request assistance <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
              <Link to="/quote">
                <Button variant="outline" className="squircle h-14 px-8 border-[#1F0068] text-[#1F0068] hover:bg-[#1F0068] hover:text-white text-base font-semibold">
                  Get a plan
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngineersSection;
